var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.491,3H10A2.506,2.506,0,0,0,7.5,5.5V25.486A2.5,2.5,0,0,0,10,27.972l12.492.012a2.506,2.506,0,0,0,2.5-2.5V5.5A2.506,2.506,0,0,0,22.491,3ZM16.245,5.5a2.5,2.5,0,1,1-2.5,2.5A2.506,2.506,0,0,1,16.245,5.5Zm0,19.988a6.246,6.246,0,1,1,6.246-6.246A6.249,6.249,0,0,1,16.245,25.486Zm0-9.994a3.748,3.748,0,1,0,3.748,3.748A3.743,3.743,0,0,0,16.245,15.492Z",
    transform: "translate(9.683 10.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.452)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeaker);
export default __webpack_public_path__ + "static/media/icon-speaker.849ab0ee032eba8714bf6906c59557e7.svg";
export { ForwardRef as ReactComponent };